import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f8725f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "picker-container__target" }

import { nextTick, PropType, ref, watch } from "vue";
import { TirPmPopover } from "tir-pm-popover";
import { DatepickerTypeEnum, PickerGridTypeEnum } from "../../enums";
import { DatepickerPopoverProps } from "../../types";


export default /*#__PURE__*/_defineComponent({
  __name: 'picker-container',
  props: {
  /**Отображаемая сетка */
  gridType: {
    type: Number as PropType<PickerGridTypeEnum>,
    required: true,
  },
  /**Тип пикера */
  type: {
    type: String as PropType<DatepickerTypeEnum>,
    required: true,
  },
  /**Блокировка */
  isDisabled: { type: Boolean, default: false },
  /**Настройки поповера */
  popover: {
    type: Object as PropType<DatepickerPopoverProps>,
    required: true,
  },
},
  emits: ["open", "close"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





/**Ссылка на компонент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();
/**Флаг открыт ли поповер */
const isOpened = ref(false);

/**При открытии */
const onOpen = () => {
  isOpened.value = true;
  emit("open");
};
/**При закрытии */
const onClose = () => {
  isOpened.value = false;
  emit("close");
};
/**Открыть */
const open = () => $popover.value?.open();
/**Закрыть */
const close = () => $popover.value?.close();
/**Открыть/закрыть */
const toggle = () => {
  if (isOpened.value) close();
  else open();
};

/**Обновление позиционирования поповера при смене сетки */
watch(
  () => props.gridType,
  async () => {
    await nextTick();
    $popover.value?.init(true);
  }
);

__expose({
  open,
  close,
  toggle,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    ref_key: "$popover",
    ref: $popover,
    class: _normalizeClass(['picker-container-popover', `input-type--${__props.type}`]),
    classes: "picker-container",
    position: __props.popover.position,
    "custom-position": __props.popover.customPosition,
    "is-disabled": __props.isDisabled,
    "is-no-teleport": __props.popover.isNoTeleport,
    "data-picker-container-popover": "",
    onOpen: onOpen,
    onClose: onClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", {
        class: "picker-container__content",
        ref: "$content",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        _renderSlot(_ctx.$slots, "content")
      ], 512)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {
          open: open,
          close: close,
          toggle: toggle
        })
      ])
    ]),
    _: 3
  }, 8, ["class", "position", "custom-position", "is-disabled", "is-no-teleport"]))
}
}

})